import { Link } from "react-router-dom";
import lightHomeImg from "../../assets/images/home-eight/home-img-eight-2.png";
import cat1 from "../../assets/images/cta-1.svg";
import cat2 from "../../assets/images/cta-2.svg";
import catcircle from "../../assets/images/cta-circle.svg";

export default function BPayDemo() {
  return (
    <section id="bpaydemo">
      <div className="w-full max-w-[1590px] md:-mt-16 rounded-b-[20px] overflow-hidden mx-auto relative flex flex-col items-center">
        <img src={catcircle} alt="" className="absolute top-0 max-w-full" />
        <a
          href="https://www.youtube-nocookie.com/embed/JdqL89ZZwFw?si=jnriuBsR3pv2EoUa"
          aria-label="play-video"
          className="video-play-btn flex space-x-8 items-center mt-[130px]"
        >
          <span className="flex size-11 sm:size-[56px] rounded-full justify-center items-center bg-blue-sass/10 relative">
            <span>
              <svg
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9611 8.29308L2.99228 12.8467C1.65896 13.6086 0 12.6459 0 11.1102V2.00295C0 0.467309 1.65896 -0.495425 2.99228 0.266469L10.9611 4.82011C12.3048 5.5879 12.3048 7.52529 10.9611 8.29308Z"
                  fill="#007AFF"
                />
              </svg>
            </span>
            <div className="absolute w-full h-full rounded-full h8-play-btn-line1"></div>
            <div className="absolute w-[130%] h-[130%] rounded-full h8-play-btn-line2"></div>
            <div className="absolute w-[160%] h-[160%] rounded-full h8-play-btn-line3"></div>
          </span>
        </a>
        <h1 className="text-24 sm:text-48 font-semibold text-main-black my-10 max-w-[640px] text-center">
          BPay Demo
        </h1>
        <Link to="/pricing">
          <div className="text-white home-two-btn-white group before:bg-blue-sass after:bg-blue-sass hover:text-main-black hover:border-main-black/10">
            <span className="relative z-10 py-1 text-base font-semibold transition-all duration-300 delay-100 group-hover:text-main-black font-inter">
              Start Free 30-days Trial
            </span>
            <svg
              className="relative z-10"
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className="transition-all duration-300 group-hover:stroke-main-black stroke-white"
                d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </Link>
        <div className="hidden md:block h-[400px] mt-[130px] w-4/5 mx-auto">
          <img src={lightHomeImg} alt="" className=" relative z-10" />
        </div>
        <img
          src={cat1}
          alt=""
          className="hidden md:block absolute bottom-0 left-0 z-0 cta_bg_anim"
        />
        <img
          src={cat2}
          alt=""
          className="hidden md:block absolute bottom-0 right-0 z-0 cta_bg_anim"
        />
      </div>
    </section>
  );
}
